// Color palettes for day/night cycle
// These are GLOBAL environmental colors (sky, fog, lighting, clouds)
// Biome-specific colors (terrain, rocks, shrubs) are defined in each biome

export const COLOR_PALETTES = [
    // ═══════════════════════════════════════════════════════════════════════════
    // DAY - Warm sunny day
    // ═══════════════════════════════════════════════════════════════════════════
    {
        name: 'Day',
        skyColorTop: 0x1e5799,      // Rich blue at zenith
        skyColorBottom: 0x87ceeb,   // Light sky blue at horizon
        fogColor: 0xa8c8dc,         // Soft blue-gray atmospheric haze
        cloudColors: [0xffffff, 0xfefefe, 0xf8f8ff],
        cloudOpacity: 0.85,
        ambientLightColor: 0xfff8f0,
        ambientLightIntensity: 0.20,      // Low ambient - sun is main light
        directionalLightColor: 0xfffff0,
        directionalLightIntensity: 1.2,   // Strong sun for shadows
        sunColor: 0xfffacd,
        vegetationEmissiveIntensity: 0.3  // Normal emissive for bright day
    },

    // ═══════════════════════════════════════════════════════════════════════════
    // SUNSET - Golden hour with warm oranges and long shadows
    // ═══════════════════════════════════════════════════════════════════════════
    {
        name: 'Sunset',
        skyColorTop: 0x2d1b4e,      // Deep purple at zenith
        skyColorBottom: 0xff6b35,   // Intense orange at horizon
        fogColor: 0xd4845a,         // Warm amber haze
        cloudColors: [0xffa060, 0xff8050, 0xe8a0b0, 0xd090a0],
        cloudOpacity: 0.9,
        ambientLightColor: 0xffc8a0,
        ambientLightIntensity: 0.15,      // Low ambient for dramatic shadows
        directionalLightColor: 0xff8040,
        directionalLightIntensity: 1.3,   // Strong low sun
        sunColor: 0xff4500,
        vegetationEmissiveIntensity: 0.05 // Very low emissive to blend with warm light
    },

    // ═══════════════════════════════════════════════════════════════════════════
    // NIGHT - Cool moonlit blues, visible but dark
    // ═══════════════════════════════════════════════════════════════════════════
    {
        name: 'Night',
        skyColorTop: 0x06060c,      // Deeper night sky
        skyColorBottom: 0x121220,   // Darker purple at horizon
        fogColor: 0x1a1a28,         // Slightly lighter fog so terrain shows
        cloudColors: [0x4a5068, 0x5a6078, 0x485060, 0x6070a0],
        cloudOpacity: 0.35,
        ambientLightColor: 0x4466aa,
        ambientLightIntensity: 0.10,
        directionalLightColor: 0x8899bb,  // Moonlight
        directionalLightIntensity: 0.18,
        sunColor: 0x000000,
        vegetationEmissiveIntensity: 0  // No emissive at night - dark silhouettes
    },

    // ═══════════════════════════════════════════════════════════════════════════
    // DAWN - Soft pastels, fresh morning light emerging
    // ═══════════════════════════════════════════════════════════════════════════
    {
        name: 'Dawn',
        skyColorTop: 0x7080a0,      // Soft blue-gray at zenith
        skyColorBottom: 0xffd4b0,   // Peachy pink at horizon
        fogColor: 0xc8b0a0,         // Soft warm haze
        cloudColors: [0xfff0e8, 0xffe8d8, 0xf8e0d0, 0xffd8c8],
        cloudOpacity: 0.75,
        ambientLightColor: 0xffe0c8,
        ambientLightIntensity: 0.18,      // Low ambient for morning shadows
        directionalLightColor: 0xffb090,
        directionalLightIntensity: 0.9,   // Soft morning sun
        sunColor: 0xffd0a0,
        vegetationEmissiveIntensity: 0.15 // Soft emissive for morning light
    }
];

// Map palette index to phase name for music
export function getPhaseName(paletteIndex) {
    const phaseNames = ['day', 'sunset', 'night', 'dawn'];
    return phaseNames[paletteIndex];
}

// Time of day indices for biome color lookups
export const TIME_OF_DAY = {
    DAY: 0,
    SUNSET: 1,
    NIGHT: 2,
    DAWN: 3
};
